/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Idle_DescriptionInputs */

const en_directory_search_idle_description = /** @type {(inputs: Directory_Search_Idle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a product name, category, workflow, or capability. Results update from the published directory.`)
};

const zh_directory_search_idle_description = /** @type {(inputs: Directory_Search_Idle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尝试输入产品名称、分类、工作流或能力。结果来自当前已发布目录。`)
};

/**
* | output |
* | --- |
* | "Try a product name, category, workflow, or capability. Results update from the published directory." |
*
* @param {Directory_Search_Idle_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_idle_description = /** @type {((inputs?: Directory_Search_Idle_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Idle_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_idle_description(inputs)
	return zh_directory_search_idle_description(inputs)
});
export { directory_search_idle_description as "directory.search.idle_description" }